export default "__VITE_ASSET__Cqzm4cCi__"